import { SyncedCharacterController } from "../synced_character_controller";

export class PlayerHandCharacterController extends SyncedCharacterController {

    constructor() {
        super();
    }
}